<template lang="pug">
    include ../../../media/pug/mixins.pug
    +b.modal-content
        +e.P.text._sm Вы действительно хотите удалить метку «{{ title }}»
        +e.BUTTON.btn._top.btn._theme_danger._size_md(
            type="button"
            v-on:click="deleteMark"
        ) Удалить

</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            title: ''
        };
    },
    computed: {
        ...mapGetters([
            'getMarks',
            'getAreas',
            'getActiveMark',
            'getActiveArea'
        ])
    },
    created() {
        this.title = this.getActiveMark ? this.getActiveMark.text : this.getActiveArea.text;
    },
    methods: {
        deleteMark() {
            if (this.getActiveArea) {
                const idx = this.getAreas.indexOf(this.getActiveArea);
                if (idx !== -1) {
                    this.$store.commit('REMOVE_AREA', idx);
                }
            } else if (this.getActiveMark) {
                const idx = this.getMarks.indexOf(this.getActiveMark);
                if (idx !== -1) {
                    this.$store.commit('REMOVE_MARK', idx);
                }
            }
            this.$store.dispatch('closeModal');
        }
    }
};
</script>
